import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import findIndex from 'lodash/findIndex';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data, Editors } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { SkyLightStateless } from 'react-skylight';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import checkPermission from '../Common/permissions';
import { companyCodeTitle, isEKC, isLMH, isBRO, isSDR, isCRW, isSC} from '../../actions/root_url';
var DropDownEditor = Editors.DropDownEditor;
const styles = {
  createDialogStyle: {
    width: '500px',
    height: '300px',
    marginLeft: '-15%',
  },
};

const contextTypes = {
  router: PropTypes.object,
};

const propTypes = {
  multiTaxesEdited: PropTypes.bool,
  multiTaxesIsEditing: PropTypes.bool,
  taxRatesIsLoading: PropTypes.bool,
  taxRatesError: PropTypes.string,
  taxIsDeleting: PropTypes.bool,
  taxDeleted: PropTypes.bool,
  taxDeleteError: PropTypes.string,
  taxRates: PropTypes.arrayOf(PropTypes.shape({})),
  fetchTaxRates: PropTypes.func.isRequired,
  editMultiTaxes: PropTypes.func.isRequired,
  deleteTax: PropTypes.func.isRequired,
};

const defaultProps = {
  multiTaxesEdited: false,
  multiTaxesIsEditing: false,
  taxRatesIsLoading: false,
  taxIsDeleting: false,
  taxDeleted: false,
  taxDeleteError: '',
  taxRatesError: '',
  taxRates: [],
};

class TaxManagement extends Component {
  constructor() {
    super();
    this.state = {
      taxValues: {
        rows: [],
        selectedRows: [],
        editedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        showConfirmationModal: false,
      },
    };
    this.closeConfirmationModal = this.closeConfirmationModal.bind(this);
    this.openConfirmationModal = this.openConfirmationModal.bind(this);
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    if (this.props.taxRates) {
      const { taxRates } = this.props;
      taxRates.map((taxRate, index) => {
        taxRate.Idx = index;
      });
      const taxValues = {
        ...this.state.taxValues,
        rows: taxRates,
        filters: {},
        sortColumn: null,
        sortDirection: null,
      };
      this.setState({ taxValues });
    }
    this.props.fetchTaxRates();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.taxRates && nextProps.taxRates !== this.props.taxRates) {
      const { taxRates } = nextProps;
      taxRates.map((taxRate, index) => {
        taxRate.Idx = index;
      });
      const taxValues = {
        ...this.state.taxValues,
        rows: taxRates,
        editedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      };
      this.setState({ taxValues });
    }
    if (nextProps.multiTaxesEdited && nextProps.multiTaxesEdited !== this.props.multiTaxesEdited) {
      this.props.fetchTaxRates();
    }
  }

  clickNew = () => {
    this.handleClearFilters();
    const rows = cloneDeep(this.state.taxValues.rows);
    const index = rows.length;
    const newRow = {
      Name: null,
      Rate: null,
      State: null,
      Zipcode: null,
      City: null,
      County: null,
      Idx: index,
    };
    rows.push(newRow);
    const editedRows = cloneDeep(this.state.taxValues.editedRows);
    editedRows.push(newRow);
    const taxValues = {
      ...this.state.taxValues,
      rows,
      editedRows,
    };
    this.setState({ taxValues });
  }

  updateRows = () => {
    const editedRows = this.state.taxValues.editedRows.map(row => {
      if (row.Company_id_id) {
        row.Company_id_id = +row.Company_id_id;
      } else {
        row.Company_id_id = null;
      }
      return row;
    });
    this.props.editMultiTaxes(editedRows);
  }

  deleteTax = () => {
    const taxAreaId = this.state.taxValues.selectedRows[0].TaxArea_id;
    if (taxAreaId) {
      this.props.deleteTax(taxAreaId).then(() => {
        this.props.fetchTaxRates();
      });
    } else {
      const rows = cloneDeep(this.state.taxValues.rows);
      const editedRows = cloneDeep(this.state.taxValues.editedRows);
      let index = findIndex(rows, { Idx: this.state.taxValues.selectedRows[0].Idx });
      rows.splice(index, 1);
      index = findIndex(editedRows, { Idx: this.state.taxValues.selectedRows[0].Idx });
      editedRows.splice(index, 1);
      const taxValues = {
        ...this.state.taxValues,
        rows,
        editedRows,
        selectedRows: [],
      };
      this.setState({
        taxValues,
        showConfirmationModal: false,
      });
    }
  }

  handleClearFilters = () => {
    const taxValues = { ...this.state.taxValues, filters: {} };
    this.setState({ taxValues });
  };

  openConfirmationModal() {
    this.setState({
      showConfirmationModal: true,
    });
  }

  closeConfirmationModal() {
    this.setState({
      showConfirmationModal: false,
    });
  }

  renderTable = () => {
    if (this.props.taxRatesIsLoading && !this.props.taxRatesError) {
      return <Spinner />;
    } else if (this.props.taxRatesError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            { JSON.stringify(this.props.taxRatesError) }
          </div>
        </ContentWrapper>
      );
    }

    const getRows = () => Data.Selectors.getRows(this.state.taxValues);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const taxValues = Object.assign({}, this.state.taxValues, { sortColumn, sortDirection });
      this.setState({ taxValues });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.taxValues.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const taxValues = { ...this.state.taxValues, filters: newFilters };
      this.setState({ taxValues });
    };

    const handleRowUpdated = (e) => {
      // merge updated row with current row and rerender by setting state
      this.setState({ sortColumn: null, sortDirection: null });
      const rows = getRows();
      const editedRows = this.state.taxValues.editedRows.slice(0);
      Object.assign(rows[e.rowIdx], e.updated);
      // if the element is already edited, remove the old one.
      editedRows.forEach((element, index) => {
        if (element.Idx === rows[e.rowIdx].Idx) {
          editedRows.splice(index, 1);
        }
      });
      // push the row into the editedRows array
      editedRows.push(rows[e.rowIdx]);
      const taxValues = {
        ...this.state.taxValues,
        rows,
        editedRows,
      };
      this.setState({ taxValues });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      const taxValues = { ...this.state.taxValues, rows: newRows, selectedRows: [rows[0].row] };
      this.setState({ taxValues });
    };

    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      const taxValues = { ...this.state.taxValues, rows: newRows, selectedRows: [] };
      this.setState({ taxValues });
    };

    const columns = [
      {
        key: 'Name',
        name: <Translate value="name" />,
        resizable: true,
        editable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
      {
        key: 'Rate',
        name: <Translate value="rate" />,
        resizable: true,
        editable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
      {
        key: 'State',
        name: <Translate value="state" />,
        resizable: true,
        editable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
      {
        key: 'Zipcode',
        name: <Translate value="zipcode" />,
        resizable: true,
        editable: true,
        width: 110,
        sortable: true,
        filterable: true,
      },
      {
        key: 'City',
        name: <Translate value="city" />,
        resizable: true,
        editable: true,
        width: 110,
        sortable: true,
        filterable: true,
      },
      {
        key: 'County',
        name: <Translate value="county" />,
        resizable: true,
        editable: true,
        width: 110,
        sortable: true,
        filterable: true,
      },
    ];
    
    if (isEKC || isLMH || isBRO || isSDR || isCRW || isSC) {
      columns.push({
        key: 'Company_id_id',
        name: <Translate value="company" />,
        resizable: true,
        editable: true,
        width: 200,
        editor: <DropDownEditor options={[{id: null, value: null, text: ''}, ...this.props.companySelection]} />,
        formatter: ({
          value
        }) => {
          const company = this.props.companySelection.find(company => company.id === +value);
          if (company) {
            return <span>{company.text}</span>;
          }
          return <span></span>;
        }
      })
    }

    return (
      <Row>
        <Col sm={12}>
          <div style={{ maxWidth: '100%' }} id="TaxManagement-dataGrid1">
            <ReactDataGrid
              rowKey="TaxArea_id"
              enableCellSelect
              onGridSort={handleGridSort}
              onClearFilters={this.handleClearFilters}
              toolbar={<Toolbar enableFilter />}
              onAddFilter={handleFilterChange}
              onRowUpdated={handleRowUpdated}
              rowHeight={25}
              minHeight={675}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              enableRowSelect="single"
              rowSelection={{
                onRowsSelected,
                onRowsDeselected,
                showCheckbox: true,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
            />
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="admin_tools" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="tax_management" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="tax-management">
          <Row>
            <Panel id="tax-management-table">
              <ButtonToolbar className="tax-management-table-buttons">
                <Button
                  bsStyle="primary"
                  className="buttonStyle"
                  onClick={event => this.clickNew(event)}
                  disabled={!checkPermission('add_tax_area')}
                >
                  <em className="fa fa-plus marginRightStyle" />
                  <Translate value="create" />
                </Button>
                <Button
                  bsStyle="success"
                  className="buttonStyle"
                  onClick={event => this.updateRows(event)}
                  disabled={this.state.taxValues.editedRows.length === 0 || !checkPermission('change_tax_area')}
                >
                  <em className="fa fa-save marginRightStyle" />
                  <Translate value="save" />
                </Button>
                <Button
                  bsStyle="danger"
                  className="buttonStyle"
                  onClick={this.openConfirmationModal}
                  disabled={this.state.taxValues.selectedRows.length === 0 || !checkPermission('delete_tax_area')}
                >
                  <em className="fa fa-trash marginRightStyle" />
                  <Translate value="delete" />
                </Button>
                <SkyLightStateless
                  dialogStyles={styles.createDialogStyle}
                  isVisible={this.state.showConfirmationModal}
                  onCloseClicked={this.closeConfirmationModal}
                  title={<Translate value="delete_tax" />}
                >
                  <Row className="centerStyle" style={{ marginTop: '20px' }}>
                    <h4><Translate value="msg_confirm_delete" /></h4>
                  </Row>
                  <Row className="centerStyle" style={{ marginTop: '80px' }}>
                    <Button
                      bsStyle="primary"
                      onClick={event => this.deleteTax(event)}
                      style={{ float: 'none' }}
                    >
                      <em className="fa fa-check" /><Translate value="Confirm" />
                    </Button>
                  </Row>
                </SkyLightStateless>
              </ButtonToolbar>
              <div id="edit-information">
                {
                  this.props.multiTaxesIsEditing && !this.props.multiTaxesEdited
                    && (
                      <div className="alert alert-info groups-saving-info">
                        <Translate value="saving" />
                      </div>
                    )
                }
                {
                  !this.props.multiTaxesIsEditing && this.props.multiTaxesEdited
                    && (
                      <div className="alert alert-success groups-saving-info">
                        <Translate value="saved" />
                      </div>
                    )
                }
                {
                  this.props.taxIsDeleting && !this.props.taxDeleted && !this.props.taxDeleteError
                    && (
                      <div className="alert alert-info groups-saving-info">
                        <Translate value="deleting" />
                      </div>
                    )
                }
                {
                  !this.props.taxIsDeleting && this.props.taxDeleted && !this.props.taxDeleteError
                    && (
                      <div className="alert alert-success groups-saving-info">
                        <Translate value="deleted" />
                      </div>
                    )
                }
                {
                  !this.props.taxIsDeleting && !this.props.taxDeleted && this.props.taxDeleteError
                    && (
                      <div className="alert alert-danger groups-saving-info">
                        { this.props.taxDeleteError }
                      </div>
                    )
                }
              </div>
              { this.renderTable() }
            </Panel>
          </Row>
        </Grid>
      </ContentWrapper>
    );
  }
}

TaxManagement.contextTypes = contextTypes;
TaxManagement.propTypes = propTypes;
TaxManagement.defaultProps = defaultProps;

export default TaxManagement;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/taxManagement.jsx